export default {
  title: 'Minimalna kwota płatności: Płatności nie mogą mieścić się między {{rangeStart}} - {{rangeEnd}}',
  description: 'Wyjątek: Gdy masz darmowy produkt, możesz złożyć zamówienie na łączną kwotę {{amount}}.',
};
